webModule.directive('responsiveSidebars', function() {
    return {
        controller: function($scope, $window) {
            $scope.showLeftSidebar = true;
            $scope.showRightSidebar = true;

            var breakpoint1 = 1024;
            var breakpoint2 = 800;
            var updateSidebars = function(newScreenWidth, oldScreenWidth) {
                if (newScreenWidth > breakpoint1 && oldScreenWidth <= breakpoint1)
                    $scope.showRightSidebar = true;
                else if (newScreenWidth <= breakpoint1 && oldScreenWidth > breakpoint1)
                    $scope.showRightSidebar = false;

                if (newScreenWidth > breakpoint2 && oldScreenWidth <= breakpoint2)
                    $scope.showLeftSidebar = true;
                else if (newScreenWidth <= breakpoint2 && oldScreenWidth > breakpoint2)
                    $scope.showLeftSidebar = false;
            };

            $scope.$watch(function () {
                return $window.outerWidth;
            }, updateSidebars);

            angular.element($window).bind('resize', function () {
                $scope.$apply();
            });

            // initialize the sidebars on show
            updateSidebars($window.outerWidth, breakpoint1+1);
        }
    };
});
